import { css as n } from "styled-components";
const i = n`
  box-sizing: border-box;
  margin: 0;
  padding: 0;

  * {
    box-sizing: border-box;
  }
`, e = n`
  background-color: transparent;
  border: none;
  font-family: inherit;
  font-weight: inherit;
  margin: 0;
  padding: 0;
`, t = n`
  margin: 0;
  padding: 0;
`, r = n`
  margin: 0;
  padding: 0;
`, a = n`
  appearance: none;
  background-color: transparent;
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;

  /* Outlines will be handled in the InputOutline component. */
  outline: none;
  padding: 0;
`, d = n`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export {
  i as Base,
  e as Button,
  a as Input,
  r as LI,
  t as UL,
  d as VisuallyHidden
};
